import { ZyInlineEnumIcon } from '@/components/tiptap-editor/tiptap-icons/zyinlineenum-icon';
import { isSelectionDescendantOf, isSelectionTopNode } from '@/lib/zy-tiptap-utils';
import type { Editor } from '@tiptap/react';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export function isInlineEnumDisabled(editor: Editor) {
    const isSelectionDescendantOfNode = ['zyExercise', 'zyExample', 'listItem'].some(node => isSelectionDescendantOf(editor, node));
    if (isSelectionTopNode(editor) || isSelectionDescendantOfNode) {
        return false;
    }
    return true;
}

const ZyInlineEnumButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyInlineEnum"
        extensionType="node"
        icon={ZyInlineEnumIcon}
        label="Insert zyInlineEnum"
        command={editor => editor.commands.insertZyInlineEnum()}
        isDisabled={editor => isInlineEnumDisabled(editor)}
        ref={ref}
        {...props}
    />
));

ZyInlineEnumButton.displayName = 'ZyInlineEnumButton';

export default ZyInlineEnumButton;
